import { render, staticRenderFns } from "./StartDP.vue?vue&type=template&id=35c4b557"
import script from "./StartDP.vue?vue&type=script&lang=js"
export * from "./StartDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports